import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable, Observer } from 'rxjs';
import { FileUploader } from 'ng2-file-upload';
import { Sweetalert2Service } from '../sweetalert2.service';
import { getObject } from 'app/shared/util/util';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { dbConfig } from 'app/shared/util/db';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  readonly API_URL = environment.serverUrl;

  constructor(
    private readonly http: HttpClient,
    private readonly _sweetalert2Service: Sweetalert2Service,
    private readonly dbService: NgxIndexedDBService,
  ) {
  }

  getListCache(url: string, pathList = 'model.result', cacheDay = 1, bypassCache = false): Promise<any[]> {
    // this.clearCache(url);
    return new Promise(async (resolve, reject) => {
      const version = localStorage.cacheVersion || null;
      const currentVersion = dbConfig.version || 0;
      try {
        const toDay = new Date();
        const cache: any = await this.dbService.getByKey('cache', url).toPromise();

        if (cache && cache?.value?.length && cache?.expire > toDay.getTime() && !bypassCache && version == currentVersion) {
          resolve(cache.value);
        } else {
          if (version != currentVersion) localStorage.cacheVersion = currentVersion;
          const res: any = await this.get(url).toPromise();
          const list = getObject(res, pathList) ?? [];

          if (res?.didError === false && list?.length && (!cache || cache?.expire < toDay.getTime()) && !bypassCache) {
            // this.setCache(url, list);

            const cacheTime = new Date(toDay.setDate(toDay.getDate() + cacheDay));
            const key = await this.dbService.update('cache', {
              key: url,
              value: list,
              expire: cacheTime.getTime(),
            }).toPromise();

            console.log(`%c ---->>> set cache  ${key}`,  'color: green; font-weight: bold');
          }
          resolve(list);
        }
      } catch (error) {
        reject(error);
      }
    });
  }

  get(url, retryCount = 2): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('api-language', 'TH');
    return this.http.get(url, {
      headers: headers
    });
  }

  post(url, data, retryCount = 2): Observable<any> {
    return this.http.post(url, data);
  }

  put(url, data, retryCount = 2): Observable<any> {
    return this.http.put(url, data);
  }

  patch(url, data, retryCount = 2): Observable<any> {
    return this.http.patch(url, data);
  }

  delete(url, retryCount = 2): Observable<any> {
    return this.http.delete(url);
  }

  getToken(): string {
    return localStorage.getItem('access_token');
  }

  setToken(token: string): void {
    localStorage.setItem('access_token', token);
  }

  setTokenType(tokenType: string): void {
    localStorage.setItem('token_type', tokenType);
  }

  setCredentials(username: string): void {
    localStorage.setItem(environment.credentialsKey, JSON.stringify({
      username,
      access_token: this.getToken()
    }));
  }

  getBinary() {

  }

  createUploadHandler(url: string): FileUploader {
    // let maxFileSize = 5 * 1024 * 1024;
    let maxFileSize = 2 * 1024 * 1024;
    const handler = new FileUploader({
      url: this.API_URL + url,
      authToken: `Bearer ${this.getToken()}`,
      authTokenHeader: 'Authorization',
      maxFileSize: maxFileSize,
      allowedMimeType: ['application/pdf',
                        'image/jpeg',
                        'image/png',
                        'application/vnd.ms-excel',
                        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                        'text/csv'],
      headers: [
        { name: 'Accept', value: 'application/json, text/plain, */*' },
      ]
    });

    handler.onBeforeUploadItem = (fileItem) => {
      try {
        console.log({
          name: fileItem.file.name,
          size: fileItem.file.size,
          type: fileItem.file.type,
        });
      } catch (e) {
      }
      return { fileItem: fileItem };
    };

    handler.onWhenAddingFileFailed = (file, filter, options) => {
      if (filter.name === 'fileSize') {

          this._sweetalert2Service.withError('แจ้งเตือน', "ไม่สามารถแนบไฟล์ได้ ระบบรองรับไฟล์ขนาดไม่เกิน 2 MB");
      }

      if(filter.name  === "mimeType"){
        this._sweetalert2Service.withError('แจ้งเตือน', "ไม่สามารถแนบไฟล์ได้ ระบบรองรับไฟล์นามสกุล .jpg, .png, .pdf, .xlsx, .xls, .csv เท่านั้น");
      }
    };

    return handler;
  }

}
